import React from "react";
import { Box, Image } from "gestalt";
import Caption from "./caption";

function Banner({ products, imageUrl, spacing }) {
  if (spacing) {
    return (
      <Box
        marginTop={10}
        marginBottom={10}
        color="darkGray"
        width="100%"
        height="75vh"
        position="relative"
      >
        <Image
          alt="wide"
          fit="cover"
          naturalHeight={1}
          naturalWidth={1}
          src={imageUrl}
        >
          <Caption products={products} />
        </Image>
      </Box>
    );
  }
  return (
    <Box color="darkGray" width="100%" height="75vh" position="relative">
      <Image
        alt="wide"
        fit="cover"
        naturalHeight={1}
        naturalWidth={1}
        src={imageUrl}
      >
        <Caption products={products} />
      </Image>
    </Box>
  );
}

export default Banner;



// WEBPACK FOOTER //
// ./src/Components/banner.js